import type { ReactNode } from "react";

interface ContentParentProps {
    children: ReactNode;
}

export const ContentParent = ({ children }: ContentParentProps) => {
    return <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-16 pt-20">{children}</div>;
};
